<template>
  <div class="home w-full bg-white">
    <div
      class="bg-purple-700 h-24 w-full fixed top-0 flex justify-between items-center"
    >
      <div class="flex h-20">
        <img class="h-full" src="@/assets/logo-plataforma_web_400.png" />
      </div>
      <div class="flex h-full text-white font-bold">
        <span class="flex items-center px-4 cursor-pointer hover:bg-purple-400"
          ><a v-on:click="scrollToHome()">Inicio</a></span
        >
        <span class="flex items-center px-4 cursor-pointer hover:bg-purple-400"
          ><a v-on:click="scrollToDownload()">Descargar</a></span
        >
        <span class="flex items-center px-4 cursor-pointer hover:bg-purple-400"
          ><a v-on:click="scrollToFaq()">Preguntas frecuentes</a></span
        >
      </div>
    </div>
    <div ref="home" class="w-full h-screen flex items-center">
      <div class="flex flex-col w-full">
        <span class="text-4xl font-bold tracking-wider pb-2">Lorem Ipsum</span>
        <span class="text-lg font-semibold px-8"
          >Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. It was popularised in the 1960s with
          the release of Letraset sheets containing Lorem Ipsum passages, and
          more recently with desktop publishing software like Aldus PageMaker
          including versions of Lorem Ipsum.</span
        >
      </div>
    </div>
    <!-- <div class="flex w-full items-center px-8 py-12">
      <span>Participa en Miapptsil</span>
    </div> -->
    <div class="flex w-full items-center bg-primary-color px-8 py-12">
      <div class="w-1/2 flex flex-col items-center">
        <span class="text-white text-4xl tracking-wider font-extrabold pb-4">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry
        </span>
        <a
          href="/registro"
          class="border-2 border-white rounded-lg cursor-pointer bg-white text-purple-400 px-4 py-2 font-semibold tracking-widest"
        >
          Regístrate
        </a>
      </div>
      <div class="w-1/2 flex flex-col items-center">
        <span class="text-white text-4xl tracking-wider font-bold pb-4"
          >¿Ya tienes una cuenta?</span
        >
        <a
          href="/login"
          class="border-2 border-white rounded-lg cursor-pointer bg-white text-purple-400 px-4 py-2 font-semibold tracking-widest"
        >
          Iniciar sesión
        </a>
      </div>
    </div>
    <div ref="download" class="w-full h-screen flex items-center">
      <div class="flex flex-col w-1/2">
        <span class="text-4xl font-bold tracking-wider pb-12"
          >Descarga nuestra aplicación</span
        >
        <div class="flex w-full flex-col md:flex-row">
          <div class="md:w-1/2 w-full flex items-center justify-center">
            <div
              class="w-1/2 mx-auto border-2 border-white rounded-lg cursor-pointer bg-purple-400 text-white"
            >
              <a
                class="w-full py-2 flex items-center justify-center"
                href="https://apps.apple.com/us/app/miapptsil/id1631616838"
                target="_blank"
              >
                <span>
                  <font-awesome-icon icon="fab fa-apple" class="h-12" />
                </span>
                <div class="flex flex-col pl-2 text-left">
                  <span class="text-xs font-semibold">Descárgalo en el</span>
                  <span class="text-lg font-bold"> App Store </span>
                </div>
              </a>
            </div>
          </div>
          <div class="md:w-1/2 w-full flex items-center justify-center">
            <div
              class="w-1/2 mx-auto border-2 border-white rounded-lg cursor-pointer bg-purple-400 text-white"
            >
              <a
                class="w-full py-2 flex items-center justify-center"
                href="https://play.google.com/store/apps/details?id=com.miatsil.miapptsil"
                target="_blank"
              >
                <span>
                  <font-awesome-icon icon="fab fa-google-play" class="h-12" />
                </span>
                <div class="flex flex-col pl-2 text-left">
                  <span class="text-xs font-semibold">Disponible en</span>
                  <span class="text-lg font-bold"> Google Play </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 px-4">
        <span class="text-4xl tracking-wider font-extrabold pb-4"
          >Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book.</span
        >
      </div>
    </div>
    <div ref="faq" class="w-full h-screen flex items-center">
      <div class="flex flex-col w-full">
        <h1 class="text-4xl font-bold tracking-wider pb-2">
          Preguntas frecuentes
        </h1>
      </div>
    </div>
  </div>
</template>

<style scoped>
.home {
  background-color: #f6f4fa;
  background-image: url("/apidev/img/bg1.jpg");
}
</style>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    scrollToFaq() {
      this.$refs["faq"].scrollIntoView({ behavior: "smooth" });
    },
    scrollToDownload() {
      this.$refs["download"].scrollIntoView({ behavior: "smooth" });
    },
    scrollToHome() {
      this.$refs["home"].scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>
